import store from '../store/store';
export function getFolderFromRawId(rawIdentity) {
    // the rawIdendity ends with the path to the folder, formatted **rest of rawIdentity**rootFolder:\pathToFolder
    var rawIdPath = rawIdentity.split(':\\')[1];
    var folders = store.contextMenuFolders;
    for (var _i = 0, folders_1 = folders; _i < folders_1.length; _i++) {
        var folder = folders_1[_i];
        if (rawIdPath === folder.path) {
            return folder;
        }
    }
    return null;
}
export function getFolderFromFolderId(folderId) {
    // the rawIdendity ends with the path to the folder, formatted **rest of rawIdentity**rootFolder:\pathToFolder
    var folders = store.contextMenuFolders;
    for (var _i = 0, folders_2 = folders; _i < folders_2.length; _i++) {
        var folder = folders_2[_i];
        if (folderId === folder.folderId) {
            // when we call this function from the create rule dialog the rawIdentity uses the folderId from the mail store
            return folder;
        }
    }
    return null;
}
export default function getFolderFromId(Id) {
    return Id.indexOf(':\\') > -1 ? getFolderFromRawId(Id) : getFolderFromFolderId(Id);
}
//# sourceMappingURL=folderTypeConversionUtil.js.map